import {FC, useEffect, useState} from 'react'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {i18n} from '../../../../translate/i18n'
import {setLanguage} from '../../../../../_metronic/i18n/Metronici18n'

type Item = {
  name: string
  language: string
}

type Props = {
  data: Item[]
}

const LanguageList: FC<Props> = (props) => {
  const {data} = props
  const [emptyData, setEmptyData] = useState<boolean>(false)

  useEffect(() => {
    if (data.length > 0) setEmptyData(false)
    else setEmptyData(true)
  }, [data.length])

  const changeLanguage = (language: string) => {
    console.log('🚀 DEBUG - Changing language to:', language)

    // Atualiza ambos os sistemas de localStorage com códigos simples para i18next
    switch (language) {
      case 'br':
        localStorage.setItem('i18nextLng', 'pt')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'pt'}))
        break
      case 'en':
        localStorage.setItem('i18nextLng', 'en')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'en'}))
        break
      case 'es':
        localStorage.setItem('i18nextLng', 'es')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'es'}))

        // Usar também a função do Metronic para garantir
        setLanguage('es')
        return // ← Sair aqui pois setLanguage já recarrega a página
      case 'fr':
        localStorage.setItem('i18nextLng', 'fr')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'fr'}))
        break
      case 'it':
        localStorage.setItem('i18nextLng', 'it')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'it'}))
        break
      case 'de':
        localStorage.setItem('i18nextLng', 'de')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'de'}))
        break
      case 'zh':
        localStorage.setItem('i18nextLng', 'zh')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'zh'}))
        break
      case 'ko':
        localStorage.setItem('i18nextLng', 'ko')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'ko'}))
        break
      case 'ja':
        localStorage.setItem('i18nextLng', 'ja')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'ja'}))
        break
      default:
        localStorage.setItem('i18nextLng', 'pt')
        localStorage.setItem('i18nConfig', JSON.stringify({selectedLang: 'pt'}))
        break
    }

    // console.log('🔍 DEBUG - After setting localStorage:', {
    //   language: language,
    //   i18nextLng: localStorage.getItem('i18nextLng'),
    //   i18nConfig: localStorage.getItem('i18nConfig'),
    // })

    // Atualiza nosso sistema i18n
    const i18nLang = language === 'br' ? 'pt' : language
    console.log('🔄 DEBUG - Calling i18n.changeLanguage with:', i18nLang)
    i18n.changeLanguage(i18nLang)

    // Força atualização do sistema Metronic também
    if (window.location) {
      console.log('🔄 DEBUG - Force updating Metronic system')
      // Aguarda um pouco antes de recarregar para garantir que o localStorage foi salvo
      setTimeout(() => {
        console.log('🔄 DEBUG - Reloading page...')

        // Reinicializa os menus Metronic após reload
        setTimeout(() => {
          if ((window as any).KTMenu) {
            ;(window as any).KTMenu.createInstances()
          }
        }, 100)

        window.location.reload()
      }, 200)
    }
  }

  return (
    <div className='py-4'>
      {!emptyData ? (
        <ul className='list-unstyled m-0'>
          {data.map((item) => (
            <li key={item.name} className='d-flex'>
              <div
                onClick={() => changeLanguage(item.language)}
                className='d-flex align-items-center w-100 px-4 py-3 cursor-pointer fs-7 fw-bold text-gray-700 bg-hover-light text-hover-primary'
              >
                <img
                  className='h-20px w-20px rounded me-4'
                  src={toAbsoluteUrl(`/media/svg/flags/${item.language}.svg`)}
                  alt=''
                />
                {item.name}
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className='p-4'>
          <div className='text-gray-600 fs-6'>Nenhum idioma encontrado</div>
        </div>
      )}
    </div>
  )
}

export {LanguageList}
